import Styles from './TextFieldLoadingState.module.scss'
import { LineSkeleton } from 'components/Skeleton/LineSkeleton'
import cx from 'classnames'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  lines?: number
  fixedHeight?: number
  fixedWidth?: number
  variant?: 'primary' | 'secondary' | 'tertiary'
}

export const TextFieldLoadingState = ({ lines = 1, variant = 'primary', fixedHeight, fixedWidth }: Props) => {
  const { isMobile } = useResponsiveDesign()
  const width = isMobile ? '100%' : fixedWidth

  return (
    <div
      style={{
        minHeight: fixedHeight,
        height: fixedHeight,
        minWidth: width,
        maxWidth: width,
        width: width,
      }}
      className={cx(Styles.stub, Styles[variant], { [Styles.oneLine]: lines === 1 })}
      data-testid="text-field-loading-state"
    >
      {Array.from(Array(lines)).map((_, index) => (
        <LineSkeleton
          key={index}
          className={Styles.shimmer}
          width={index === lines - 1 && lines > 1 ? '75%' : undefined}
        />
      ))}
    </div>
  )
}
